import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'offcanvas offcanvas-bottom src-offcanvas',
      { show: _ctx.stateStoreInstance.active },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "offcanvas-title fs-3" }, "ابحث في الموقع", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.searchModal && _ctx.stateStoreInstance.searchModal(...args)))
        })
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"offcanvas-body small\"><form class=\"src-form position-relative\"><input type=\"text\" class=\"form-control\" placeholder=\"اكتب ما تبحث عنه هنا...\"><button type=\"submit\" class=\"position-absolute top-50 end-0 translate-middle-y btn\"><span class=\"border-style\">بحث</span></button></form></div>", 1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['offcanvas-backdrop fade', { show: _ctx.stateStoreInstance.active }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.searchModal && _ctx.stateStoreInstance.searchModal(...args)))
    }, null, 2)
  ], 64))
}